import { ActionableCardViewState } from '../store/schema/ActionableCardViewState';
import ResponseMessage from '../store/schema/ResponseMessage';

/**
 * return whether we should display the actionable card component
 */
export function showActionableCard(cardState: ActionableCardViewState): boolean {
    return (
        cardState === ActionableCardViewState.ShowCard ||
        cardState === ActionableCardViewState.ActionInProgress ||
        cardState === ActionableCardViewState.ShowActionsResponse
    );
}

/**
 * return whether we should display response message
 */
export function showActionResponse(
    cardState: ActionableCardViewState,
    responseMessage: ResponseMessage
): boolean {
    return (
        cardState === ActionableCardViewState.ShowActionsResponse &&
        !!responseMessage &&
        !!responseMessage.message
    );
}

/**
 * return whether we should display spinner
 */
export function showActionInProgress(cardState: ActionableCardViewState): boolean {
    return cardState === ActionableCardViewState.ActionInProgress;
}
